var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('true-false',{attrs:{"color":_vm.state,"initial-value":_vm.currentValue},on:{"change":function($event){return _vm.beforeUpdateField(_vm.field, $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }